import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAllAdmin, updateUserData } from "../redux/admin/adminSlice";
import { toast } from "react-toastify";

function AdminEditModal({ admin, closeModal }) {
  const dispatch = useDispatch();

  const [adminFields, setAdminFields] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (admin) {
      setAdminFields({
        name: admin.name,
        email: admin.email,
        password: "",
      });
    }
  }, [admin]);

  const handleInputChange = (field, value) => {
    setAdminFields((prevFields) => ({ ...prevFields, [field]: value }));
  };

  const handleSubmit = () => {
    const updatedAdmin = {
      name: adminFields.name,
      email: adminFields.email,
      password: adminFields.password,
    };

    dispatch(updateUserData({ updatedAdmin: updatedAdmin, id: admin?.id }))
      .unwrap()
      .then(() => {
        toast.success("Admin updated successfully!");
        closeModal(false);
        dispatch(getAllAdmin());
      })
      .catch((error) => {
        toast.error(`Error updating admin: ${error?.response?.data?.error}`);
      });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative w-full max-w-lg p-6 bg-white rounded-lg shadow-lg">
        <h2 className="mb-4 text-xl font-semibold text-center">Edit Admin</h2>

        <div className="mb-4">
          <input
            type="text"
            className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Name"
            value={adminFields.name}
            onChange={(e) => handleInputChange("name", e.target.value)}
          />
          <input
            type="email"
            className="w-full p-3 my-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Email"
            value={adminFields.email}
            onChange={(e) => handleInputChange("email", e.target.value)}
          />

          <p
            onClick={() => setShowPassword(!showPassword)}
            className="pt-2 text-blue-600 underline cursor-pointer"
          >
            Change Password
          </p>
          {showPassword && (
            <input
              type="password"
              className="w-full p-3 my-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter new password"
              value={adminFields.password}
              onChange={(e) => handleInputChange("password", e.target.value)}
            />
          )}
        </div>

        <div className="flex justify-between space-x-4">
          <button
            type="button"
            onClick={() => closeModal(false)}
            className="flex-1 px-4 py-2 text-sm font-medium text-gray-500 transition duration-200 bg-white border border-gray-300 rounded-lg hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            type="button"
            className="flex-1 px-4 py-2 text-sm font-medium text-white transition duration-200 bg-blue-600 rounded-lg hover:bg-blue-700"
            onClick={handleSubmit}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminEditModal;
